import styled from 'styled-components';
import { BORDER_BOX_SIZING } from '../../../../../common/styles/Layout';
import { ThemeColours } from '../../../../styles/ThemeColours';
import {
  Breakpoint,
  FontWeight,
  FontSize,
  LineHeight,
  FONT_STACK,
} from '../../../../styles/constants';
import { TopServicesBox } from './TopServicesBox/TopServicesBox';

export const Container = styled.div`
  ${BORDER_BOX_SIZING}
  display: flex;
  flex-flow: column nowrap;
  margin-right: 8px;

  ${Breakpoint.SMALL} {
    margin: 0px;
  }
`;

export const Header = styled.div`
  display: block;
  height: 112px;
  margin: 0;
  padding-bottom: 16px;

  ${Breakpoint.SMALL} {
    height: 84px;
    padding-bottom: 4px;
  }
`;

export const Title = styled.p`
  ${FONT_STACK}
  color: ${ThemeColours.mono900};
  font-size: ${FontSize.LARGE};
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: ${LineHeight.HEADING_6};
  margin: 0;
`;

export const SubTitle = styled.p`
  ${FONT_STACK}
  color: ${ThemeColours.mono700};
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.REGULAR};
  line-height: ${LineHeight.REGULAR};
  margin-top: 16px;

  ${Breakpoint.SMALL} {
    margin-top: 0px;
  }
`;

export const PillContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 12px;

  ${Breakpoint.SMALL} {
    margin-bottom: 0px;
  }
`;

export const StyledTopServicesBox = styled(TopServicesBox)`
  border: 1px solid ${ThemeColours.mono200};
  border-radius: 8px;
  flex: 0 0 auto;
  margin: 12px 8px 0 0;
  min-width: 100px;
`;
